<div class="admin-payouts-table">
  @if (payouts().length === 0) {
    <p class="admin-payouts-table__empty">No payout requests found.</p>
  } @else {
    <table
      mat-table
      [dataSource]="payouts()"
      class="admin-payouts-table__table"
    >
      <!-- User Email Column -->
      <ng-container matColumnDef="userEmail">
        <th mat-header-cell *matHeaderCellDef>User Email</th>
        <td mat-cell *matCellDef="let payout">{{ payout.userEmail }}</td>
      </ng-container>

      <!-- Payment Name Column -->
      <ng-container matColumnDef="paymentName">
        <th mat-header-cell *matHeaderCellDef>Payment Name</th>
        <td mat-cell *matCellDef="let payout">{{ payout.paymentName }}</td>
      </ng-container>

      <!-- Payment Email Column -->
      <ng-container matColumnDef="paymentEmail">
        <th mat-header-cell *matHeaderCellDef>Payment Email</th>
        <td mat-cell *matCellDef="let payout">{{ payout.paymentEmail }}</td>
      </ng-container>

      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let payout">
          {{ payout.amount | currency }}
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let payout">
          <mat-chip
            highlighted
            [class]="
              'admin-payouts-table__status-chip admin-payouts-table__status-chip--' +
              payout.status
            "
          >
            {{ getStatusLabel(payout.status) }}
          </mat-chip>
        </td>
      </ng-container>

      <!-- Created At Column -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef>Requested</th>
        <td mat-cell *matCellDef="let payout">
          {{ payout.createdAt | date: "short" }}
        </td>
      </ng-container>

      <!-- Updated At Column -->
      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef>Last Updated</th>
        <td mat-cell *matCellDef="let payout">
          {{ payout.updatedAt | date: "short" }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let payout">
          @if (canMoveToNextStatus(payout.status)) {
            <div class="admin-payouts-table__actions">
              <button
                mat-raised-button
                color="primary"
                (click)="updateStatus(payout)"
              >
                Mark as {{ getNextStatusLabel(payout.status) }}
              </button>
              @if (canCancel(payout.status)) {
                <button
                  mat-stroked-button
                  color="warn"
                  (click)="cancelPayout(payout)"
                >
                  Cancel
                </button>
              }
            </div>
          } @else {
            <span class="admin-payouts-table__completed">
              @if (payout.status === "paid") {
                Completed
              } @else if (payout.status === "cancelled") {
                Cancelled
              }
            </span>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</div>
